import React from "react";
import { Icon, nuOrderTheme } from "@nuorder/components";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";

interface IProps {
    hasFilters?: boolean;
}

export const FiltersIcon: React.FC<IProps> = ({ hasFilters }) => {
    const iconStyles = React.useMemo(
        () => ({
            root: {
                fontSize: 18,
                cursor: "pointer",
                color: hasFilters ? theme.palette.primary1Color : nuOrderTheme.palette.greyDark,
                marginLeft: "12px",
            },
        }),
        [hasFilters]
    );
    return (
        <Icon
            data-test={DATATEST.ASSORTMENTS.DIMENSIONS_FILTER.OPEN}
            iconName="filter"
            className=""
            styles={iconStyles}
        />
    );
};
